import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ClustersService } from 'src/api/v2';
import { EXTERNAL_SERVICE_PROVIDER_KEY } from 'src/constants/hook-keys';

type Args = {
  serviceProviderId: string;
};

export const useExternalServiceProvider = ({ serviceProviderId }: Args) => {
  const [clustersService] = useState(new ClustersService());

  const { data, ...rest } = useQuery({
    queryKey: [EXTERNAL_SERVICE_PROVIDER_KEY, serviceProviderId],
    queryFn: () => clustersService.getExternalServiceProviderDetails(serviceProviderId),
    enabled: serviceProviderId.length > 0,
  });

  return {
    serviceProvider: data,
    ...rest,
  };
};
